<svelte:head>
	<title>SUNstack</title>
</svelte:head>

<script>
		// you may need to edit this code once to get it to work..
		// hacky way to get the userbase code (puttin in svelte:head didn't work)
	  var script = document.createElement( "script" );
    script.src='https://sdk.userbase.com/2/userbase.js';
    document.head.appendChild( script );

    let userObject = null;
    const userbase = window.userbase;
    let authPromise = userbase.init({appId: 'c85343a5-c372-46f5-b6e0-e49432c92145'})
        .then(({user}) => userObject = user)
    let username, password;
    const signIn = () => authPromise = userbase.signIn({username, password}).then(user => userObject = user);
    const signUp = () => authPromise = userbase.signUp({username, password}).then(user => userObject = user);
    const signOut = () => authPromise = userbase.signOut().then(() => userObject = null)
    let todoPromise, todos = [], newTodo =  {
  "squadName": " ",
  "homeTown": " ",
  "formed": 0,
  "secretBase": "",
  "activa": false,
  "scoops": 0,
  "fecha": " "
		};
    const databaseName = 'todos';
    function changeHandler(items) {todos = items}
    $: if (userObject) todoPromise = userbase.openDatabase({databaseName, changeHandler})
    function addTodo() {
        todoPromise = userbase.insertItem({databaseName, item: newTodo})
        newTodo = {
  "squadName": " ",
  "homeTown": " ",
  "formed": 0,
  "secretBase": " ",
  "activa": false,
  "scoops": 0,
  "fecha": " "

  
		}
    };
    function deleteTodo(itemId) {
        todoPromise = userbase.deleteItem({databaseName, itemId});
    }
    function updateTodo(index) {
        const {item, itemId} = todos[index];
        todoPromise = userbase.updateItem({databaseName, itemId, item});
	}

	let hoy = new Date().toDateString();
</script>
<div>
<h1>
	{hoy}
</h1>
{#await authPromise}Loading...{:then _}
    {#if !userObject}
    <form>
        <label for="username">Username</label>
        <input id="username" type="text" bind:value={username}><br>
        <label for="password">Password</label>
        <input id="password" type="password" bind:value={password}><br>
        <button on:click={signIn} type="button">Sign in</button>
        <button on:click={signUp} type="button">Sign up</button>
    </form>
    {:else}
        <h1>Hi, {userObject.username}!</h1>
        <button on:click={signOut} style="position: absolute; top: 10px; right: 10px;">Log out</button>
        {#await todoPromise}Loading todos..{:then _}
			<label for="new-todo">New Todox</label>
			<input id="new-todo" type="text" bind:value={newTodo.squadName}>
			<input id="new-todo" type="text" bind:value={newTodo.homeTown}>
			<input id="new-todo" type="number" bind:value={newTodo.formed}>
			<textarea id="new-todo" bind:value={newTodo.secretBase}></textarea>
			<input id="new-todo" type="checkbox" bind:checked={newTodo.activa}>
			<h2>Size</h2>

<label>
	<input type=radio bind:group={newTodo.scoops} value={1}>
	Normal
</label>

<label>
	<input type=radio bind:group={newTodo.scoops} value={2}>
	Alta
</label>

<label>
	<input type=radio bind:group={newTodo.scoops} value={3}>
	Urgente
</label>
			
            <button on:click={addTodo}>Add todo</button><br>
			{#each todos as {item, itemId}, index}
			<input type="text" bind:value={todos[index].item.squadName} on:blur={() => updateTodo(index)}>
				<input type="text" bind:value={todos[index].item.homeTown} on:blur={() => updateTodo(index)}>
				<input type="number" bind:value={todos[index].item.formed} on:blur={() => updateTodo(index)}>
				<textarea bind:value={todos[index].item.secretBase} on:blur={() => updateTodo(index)}></textarea>
				
				<input type="checkbox" bind:checked={todos[index].item.activa} on:blur={() => updateTodo(index)}>
				<label>
				<input type="radio" bind:group={todos[index].item.scoops} value={1} on:blur={() => updateTodo(index)}>
				Normal
			</label>
			<label>
				<input type="radio" bind:group={todos[index].item.scoops} value={2} on:blur={() => updateTodo(index)}>
				Alta
			</label>
			<label>
				<input type="radio" bind:group={todos[index].item.scoops} value={3} on:blur={() => updateTodo(index)}>
				Urgente
			</label>
<h2>
	{todos[index].item.fecha } {hoy}
</h2>
                <button on:click={() => deleteTodo(itemId)}>X</button><br>
            {/each}
        {:catch error} Error! {error} {/await}
    {/if}
{:catch error} Error! {error} {/await}
	
</div>
<style>
	textarea { width: 30%; height: 40px; }
</style>
